/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  InventoryControllerDeletePathParameters,
  InventoryControllerFindAllPathParameters,
  InventoryControllerGetAvailableFiltersParams,
  InventoryControllerGetAvailableFiltersPathParameters,
  InventoryControllerRegisterDevicePathParameters,
  InventoryListDto,
  RegisterDeviceDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class InventoryService {
  private readonly http = inject(HttpClient);
  /**
   * Retrieves a list of inventory items with filtering, pagination, and sorting
   * @summary Get list of inventory items
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: InventoryControllerFindAllPathParameters,
    inventoryListDto: InventoryListDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/inventory`, inventoryListDto);
  }
  /**
   * Retrieves available filter options for inventory items
   * @summary Get available filters
   */

  getAvailableFilters<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: InventoryControllerGetAvailableFiltersPathParameters,
    params?: InventoryControllerGetAvailableFiltersParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/inventory/filters`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Register an inventory item, create a device at client, location, and space specified
   * @summary Register device from inventory
   */

  registerDevice<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: InventoryControllerRegisterDevicePathParameters,
    registerDeviceDto: RegisterDeviceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/inventory/register`, registerDeviceDto);
  }
  /**
   * Delete a single inventory item if it has no assigned device
   * @summary Delete inventory item
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    inventoryId,
  }: InventoryControllerDeletePathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/inventory/${inventoryId}`);
  }
}
